// Import 3rd-party dependencies
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { map } from 'rxjs/operators';

// Import project-specific dependencies
import { NotificationsService } from '@app/services/notifications/notification.service';
import { NOTIFICATIONS_COMPONENT_CONSTS } from '@app/config/constants';

interface INotificationFilter {
  title: string;
  link: string;
  count: number;
}

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit, OnDestroy {
  notifPaneBodyHeight: number;
  notifPaneTimeout: NodeJS.Timeout;
  notifPaneUpdateHeightTimeout: NodeJS.Timeout;
  notifFilters: Array<string>;
  @ViewChild('notificationsContainer') notificationsContainer: ElementRef<HTMLElement>;
  consts = NOTIFICATIONS_COMPONENT_CONSTS;

  refreshNoifList() {
    this.notificationsService.refreshNoifList();
  }

  tasks$ = this.notificationsService.tasks$;
  alerts$ = this.notificationsService.alerts$;
  notifications$ = this.notificationsService.filterOutDisabledItems(this.notificationsService.notifications$);
  allNotifs$ = this.notificationsService.filterOutDisabledItems(this.notificationsService.allNotifs$);
  
  filterButtons$ = this.allNotifs$.pipe(
    map((allNotifs) => {
      const filters: INotificationFilter[] = [];
      allNotifs.forEach((item) => {
        const index = filters.findIndex((filter) => filter.title === item.title);
        if (index > -1) {
          filters[index].count += item.count;
        } else {
          filters.push({
            title: item.title,
            link: item.link,
            count: item.count
          });
        }
      });
      return filters;
    })
  );

  constructor(private renderer: Renderer2, private notificationsService: NotificationsService) {}

  ngOnInit(): void {
    // update height for notifications pane body
    this.notifPaneTimeout = setTimeout(() => {
      this.updateNotifPaneBodyHeight();
    }, this.consts.NOTIF_PANE_TIMEOUT);
    this.notifFilters = [];
  }

  ngOnDestroy(): void {
    if (this.notifPaneTimeout) {
      clearTimeout(this.notifPaneTimeout);
    }
    if (this.notifPaneUpdateHeightTimeout) {
      clearTimeout(this.notifPaneUpdateHeightTimeout);
    }
  }

  // update height for notifications pane body
  updateNotifPaneBodyHeight(): void {
    this.notifPaneBodyHeight = 0;
    const element = this.notificationsContainer.nativeElement;
    const isNotif = element.children[0].classList.contains('notifications-wrapper');
    this.notifPaneUpdateHeightTimeout = setTimeout(() => {
      if (isNotif) {
        this.notifPaneBodyHeight =
          element.querySelector('.mat-button-toggle-group').clientHeight + Number(this.consts.NOTIF_PANE_STATIC_HEIGHT);
        this.renderer.setStyle(
          element.querySelector('.mat-tab-body.mat-tab-body-active'),
          'height',
          `calc(100vh - ${this.notifPaneBodyHeight}px)`
        );
      }
    }, this.consts.NOTIF_UPDATE_HEIGHT_TIMEOUT);
  }

  filterNotifications(filter: string): void {
    const index = this.notifFilters.findIndex((item) => item === filter);
    if (index > -1) {
      this.notifFilters.splice(index);
    } else {
      this.notifFilters.push(filter);
    }
  }
}
